import { render, staticRenderFns } from "./SxAssetView.vue?vue&type=template&id=2d264383&scoped=true&"
import script from "./SxAssetView.vue?vue&type=script&lang=js&"
export * from "./SxAssetView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d264383",
  null
  
)

export default component.exports